<template>
  <div class="i-landing-hero">
    <div
      class="eyebrow"
      :class="{ vis: visible }"
    >
      Career Strategy Assessment
    </div>
    <h1
      class="title"
      :class="{ vis: visible }"
    >
      We'll find out exactly<br />what's holding you back.
    </h1>
    <p
      class="sub"
      :class="{ vis: visible }"
    >
      Because most career problems<br /><em>aren't performance problems.</em>
    </p>
  </div>
</template>

<script setup>
defineProps({
  visible: Boolean
})
</script>

<style lang="scss" scoped>
.i-landing-hero {
  margin-bottom: 16px;

  .eyebrow {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: $amber-warm;
    margin-bottom: 16px;
    opacity: 0;
    transform: translateY(8px);
    transition: all 0.45s ease 0.12s;

    &.vis {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .title {
    font-family: $sans;
    font-size: clamp(28px, 7.5vw, 42px);
    font-weight: 800;
    line-height: 1.08;
    color: $ink;
    letter-spacing: -0.03em;
    margin-bottom: 16px;
    opacity: 0;
    transform: translateY(12px);
    transition: all 0.5s ease 0.2s;

    &.vis {
      opacity: 1;
      transform: translateY(0);
    }

    @include respond-to($breakpoint-md) {
      font-size: clamp(30px, 3.8vw, 54px);
      line-height: 1.06;
    }
  }

  .sub {
    font-family: $serif;
    font-size: clamp(18px, 4.8vw, 26px);
    font-weight: 400;
    font-style: normal;
    color: $ink-60;
    line-height: 1.4;
    opacity: 0;
    transition: opacity 0.5s ease 0.32s;

    &.vis {
      opacity: 1;
    }

    em {
      font-style: normal;
      color: $amber-warm;
    }

    @include respond-to($breakpoint-md) {
      font-size: clamp(22px, 2.8vw, 36px);
    }
  }
}
</style>
